import { FC } from 'react';

import { ICommonIconProps } from '@smartshell/ui-kit';
import cn from 'classnames';

import s from './SummaryBlock.module.scss';

interface ISummaryBlockProps {
  Icon: FC<ICommonIconProps>;
  topText: string;
  bottomText: string;
  color:
    | 'violet'
    | 'blue'
    | 'orange'
    | 'green'
    | 'gray'
    | 'red'
    | 'pink'
    | 'orange_sad';
}
export const SummaryBlock: FC<ISummaryBlockProps> = ({
  Icon,
  bottomText,
  topText,
  color,
}) => (
  <div className={s.container}>
    <div className={cn(s.icon, s[color])}>
      <Icon size="m" />
    </div>
    <div className={s.info}>
      <span className={s.top}>{topText}</span>
      <span className={s.bottom}>{bottomText}</span>
    </div>
  </div>
);
